<script setup lang="ts">
import { getTagUrl } from "~/utils/tags";

export interface TagSelectProps {
  tagType?: string;
  tagTitle?: string;
  isActive?: boolean;
}
const props = defineProps<TagSelectProps>();
const tagSrc = getTagUrl(props.tagType);
const defaultTagTitle = computed(() => (props.tagType && props.tagType.split("_")[1]) || "Other");
</script>

<template>
  <div
    class="tagSelect"
    :style="{ borderColor: isActive ? 'var(--base-primary-color)' : 'var(--base-card-bgSecondaryColor)' }"
  >
    <IconTagType
      :is-active="isActive"
      :src="tagSrc"
      :tag-type="props.tagType"
      class="mx-2"
      background-height="24px"
      background-width="24px"
      :width="12"
      :height="12"
    />
    <span class="text-main truncate w-1/2 text-body-medium capitalize" :title="props.tagTitle">
      {{ props.tagTitle || defaultTagTitle }}
    </span>
  </div>
</template>

<style lang="scss">
.tagSelect {
  @apply rounded h-[3rem] w-[calc(50%-10px)] border
  flex items-center cursor-pointer;
}
</style>
